import React from 'react';
import { FadeIn } from './FadeIn';
import { Check } from 'lucide-react';
export function PricingCards() {
  return <section className="py-3 px-3 max-w-2xl mx-auto pt-[0px] pb-[0px] space-y-[0px] mt-[20px] mb-[20px]" id="pricing" data-id="element-221">
      <FadeIn data-id="element-222">
        <h2 className="text-lg md:text-xl font-black text-center mb-3" data-id="element-223">
          ELEGÍ TU MEGAPACK
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-xl mx-auto" data-id="element-224">
        {/* Card 1 */}
        <FadeIn delay={0.1} data-id="element-225">
          <div className="bg-gray-900 border border-gray-800 rounded-xl p-3 h-full flex flex-col relative" data-id="element-226">
            <div className="mb-2" data-id="element-227">
              <h3 className="text-sm font-bold text-white flex items-center gap-1.5 mb-0.5" data-id="element-228">
                <span data-id="element-229">📘</span> MEGAPACK MANICURISTA LISTA
              </h3>
              <p className="text-gray-400 font-medium text-xs" data-id="element-230">
                6 Tomos + 6 Bonos
              </p>
            </div>

            <div className="mb-2" data-id="element-231">
              <div className="text-red-400 line-through text-sm font-medium" data-id="element-232">
                $95.000
              </div>
              <div className="text-xl font-black text-white flex items-baseline gap-1" data-id="element-233">
                $19.990{' '}
                <span className="text-xs text-gray-400 font-medium" data-id="element-234">ARS</span>
              </div>
            </div>

            <ul className="space-y-1.5 mb-3 flex-grow" data-id="element-235">
              <li className="flex items-start gap-1.5" data-id="element-236">
                <Check className="text-pink-500 shrink-0 mt-0.5" size={12} data-id="element-237" />
                <span className="text-gray-300 text-xs" data-id="element-238">
                  Acceso a los 6 Tomos completos
                </span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-239">
                <Check className="text-pink-500 shrink-0 mt-0.5" size={12} data-id="element-240" />
                <span className="text-gray-300 text-xs" data-id="element-241">
                  Los 6 Bonos de regalo
                </span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-242">
                <Check className="text-pink-500 shrink-0 mt-0.5" size={12} data-id="element-243" />
                <span className="text-gray-300 text-xs" data-id="element-244">
                  Actualizaciones de por vida
                </span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-245">
                <Check className="text-pink-500 shrink-0 mt-0.5" size={12} data-id="element-246" />
                <span className="text-gray-300 text-xs" data-id="element-247">
                  Acceso inmediato por PDF
                </span>
              </li>
            </ul>

            <a href="https://tumanualdigital.com/cart/44142450114596:1" className="w-full block text-center py-1.5 px-3 rounded-md font-bold text-sm bg-gray-800 hover:bg-gray-700 text-white transition-colors border border-gray-700" data-id="element-248">
              → QUIERO MI MEGAPACK
            </a>
          </div>
        </FadeIn>

        {/* Card 2 - Featured */}
        <FadeIn delay={0.2} data-id="element-249">
          <div className="bg-gradient-to-b from-gray-900 to-black border-2 border-pink-500 rounded-xl p-3 h-full flex flex-col relative transform md:-translate-y-1 shadow-[0_0_15px_rgba(236,72,153,0.15)]" data-id="element-250">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-pink-500 text-black font-bold px-2.5 py-0.5 rounded-full text-[10px] flex items-center gap-1 whitespace-nowrap" data-id="element-251">
              ⭐ MÁS ELEGIDO
            </div>

            <div className="mb-2 mt-1.5" data-id="element-252">
              <h3 className="text-sm font-bold text-white flex items-center gap-1.5 mb-0.5" data-id="element-253">
                <span data-id="element-254">🏆</span> MEGAPACK + MÉTODO MANICURISTA ELITE
              </h3>
              <p className="text-pink-400 font-medium text-xs" data-id="element-255">
                6 Tomos + 6 Bonos + Sistema de Escalamiento VIP
              </p>
            </div>

            <div className="mb-2" data-id="element-256">
              <div className="text-red-400 line-through text-sm font-medium" data-id="element-257">
                $130.000
              </div>
              <div className="text-xl font-black text-white flex items-baseline gap-1" data-id="element-258">
                $27.990{' '}
                <span className="text-xs text-gray-400 font-medium" data-id="element-259">ARS</span>
              </div>
            </div>

            <ul className="space-y-1.5 mb-3 flex-grow" data-id="element-260">
              <li className="flex items-start gap-1.5" data-id="element-261">
                <Check className="text-pink-500 shrink-0 mt-0.5" size={12} data-id="element-262" />
                <span className="text-gray-200 font-medium text-xs" data-id="element-263">
                  Todo lo del Megapack Base
                </span>
              </li>
              <li className="flex items-start gap-1.5 bg-pink-900/20 p-1 rounded-md -mx-1" data-id="element-264">
                <Check className="text-pink-400 shrink-0 mt-0.5" size={12} data-id="element-265" />
                <span className="text-pink-100 font-bold text-xs" data-id="element-266">
                  Método Manicurista Elite (30 páginas)
                </span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-267">
                <Check className="text-pink-500 shrink-0 mt-0.5" size={12} data-id="element-268" />
                <span className="text-gray-300 text-xs" data-id="element-269">
                  Sistema de posicionamiento VIP
                </span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-270">
                <Check className="text-pink-500 shrink-0 mt-0.5" size={12} data-id="element-271" />
                <span className="text-gray-300 text-xs" data-id="element-272">
                  Estructura de precios para cobrar 3x más
                </span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-273">
                <Check className="text-pink-500 shrink-0 mt-0.5" size={12} data-id="element-274" />
                <span className="text-gray-300 text-xs" data-id="element-275">
                  Plan maestro a 12 meses con hoja de ruta
                </span>
              </li>
            </ul>

            <a href="https://tumanualdigital.com/cart/44142450802724:1" className="w-full block text-center py-1.5 px-3 rounded-md font-bold text-sm bg-pink-500 hover:bg-pink-400 text-black transition-all hover:scale-[1.02] shadow-lg" data-id="element-276">
              → QUIERO EL MEGAPACK + MÉTODO ELITE
            </a>
          </div>
        </FadeIn>
      </div>
    </section>;
}